import { useEffect, useState } from 'react';
import { getDefaultUISettings, getPublicUISettings } from '../services/siteSettings';

function useUISettings() {
  const [settings, setSettings] = useState(getDefaultUISettings);

  useEffect(() => {
    let isMounted = true;

    const loadSettings = async () => {
      const data = await getPublicUISettings();
      if (isMounted) {
        setSettings(data);
      }
    };

    loadSettings();

    return () => {
      isMounted = false;
    };
  }, []);

  return settings;
}

export default useUISettings;
